<template>
  <div class="lang" @mouseover="isHovering = true" @mouseout="isHovering = false">
    <span>{{currentLang | lowercase}}</span>
    <img :src="'/static/img/next.svg'" >
    <a href="javascript:void(0)" v-for="(item, index) in languages" :key="item" :index="index" :item="item"
       :class="{hovering: isHovering}" @click="setLang(item)">{{item | lowercase}}</a>
  </div>
</template>

<script>
  import {mapState} from 'vuex';

  export default {
    name: 'lang.vue',
    data() {
      return {
        isHovering: false
      }
    },
    computed: mapState({
      currentLang: state => state.lang.currentLang,
      languages: state => state.lang.languages.filter(v => v !== state.lang.currentLang),
    }),
    methods: {
      setLang(lang) {
        this.$store.dispatch('lang/changeLang', lang);
      },
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/topbar/lang.vue